<template>
  <content-card>
    <template v-slot:header>
      <div class="title">{{ t("send_report.select") }}</div>
    </template>
    <template v-slot:description>
      <div class="d-flex justify-content-center flex-row align-items-center g-24">
        <button v-for="channel in channels" :key="channel" class="method-button" @click="$emit('chooseMethod', channel)" ontouchstart="">
          <div class="icon-container">
            <img class="method-icon" :src="require('../assets/' + channel + '-icon.svg')" :alt="channel" />
          </div>
          <div class="method-name">{{ t("send_report." + channel + ".name") }}</div>
        </button>
      </div>
      <button class="continue-button-clear position-relative align-self-center" @click="$emit('back')">
        <div>{{ t("button.back") }}</div>
      </button>
    </template>
  </content-card>
</template>

<script>
import { inject } from "vue";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { locale, t } = useI18n();
    const { channels } = inject("channels");
    return {
      locale,
      t,
      channels
    };
  },
  emits: ["chooseMethod", "back"],
};
</script>

<style scoped>
.method-button {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
  background: none;
  color: #e87722;
  padding: 24px;
  width: 30%;
}
.method-name {
  font-size: 20px;
  font-weight: 500;
}
.start-content-container {
  padding: 56px 146px;
}
@media (max-width: 767px) {
  .start-content-container {
    padding: 40px 50px;
  }
  .method-icon {
    width: 40px;
    height: 40px;
  }
  .method-name {
    font-size: 14px;
  }
  .method-button {
    padding: 10px;
  }
}
</style>
